import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/value8.webp';
import screenshot_target from '../../../images/letterfunnel/peterpauldevries.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter Paul de Vries"
      firstname="Peter Paul"
      companyname="Value8"
      competition="Hal Trust en Quest for Growth"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/peterpauldevries.js